module.exports = __webpack_public_path__ + "img/icon-enter.7f19b424.png";